import { __awaiter } from 'tslib';
import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Component, ViewChild, Input, EventEmitter, ViewChildren, Output, NgModule } from '@angular/core';
import { Mapper, DialogService, CallHttp } from 'vesta';
import { Subject } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { ModalIframeComponent, ModalIframeModule } from 'modal-iframe';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalModule } from 'modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const EnumDireccionesFileShare = {
    FileShareWebApi: 0,
    FileShareWebApiHttps: 1,
    FileShareWeb: 2,
    FileShareWebHttps: 3,
};
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebApi] = 'FileShareWebApi';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebApiHttps] = 'FileShareWebApiHttps';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWeb] = 'FileShareWeb';
EnumDireccionesFileShare[EnumDireccionesFileShare.FileShareWebHttps] = 'FileShareWebHttps';
class DireccionFileShare {
}
if (false) {
    /** @type {?} */
    DireccionFileShare.prototype.Direccion;
    /** @type {?} */
    DireccionFileShare.prototype.Nombre;
}
/** @type {?} */
const DireccionesFileShare = [
    { Nombre: EnumDireccionesFileShare.FileShareWeb, Direccion: 'http://fileshare.grupovesta.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebApi, Direccion: 'http://filesharewebapi.grupovesta.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebHttps, Direccion: 'https://fileshare.vesta-accelerate.com' },
    { Nombre: EnumDireccionesFileShare.FileShareWebApiHttps, Direccion: 'https://fileshareapi.vesta-accelerate.com' } // 'https://filesharewebapi-stage.azurewebsites.net' //'https://localhost:44350'
];
/** @type {?} */
let FILESHARE_WEB = new InjectionToken('FileShareWeb');
/** @type {?} */
let FILESHARE_API = new InjectionToken('FileShareApi');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
require("vesta/esm5/lib/service/array-extends");
class FileshareService {
    /**
     * @param {?} dialogService
     * @param {?} callHttp
     * @param {?} fileShareWebApi
     */
    constructor(dialogService, callHttp, fileShareWebApi) {
        this.dialogService = dialogService;
        this.callHttp = callHttp;
        this.fileShareWebApi = fileShareWebApi;
        this.Respuestas = [];
    }
    /**
     * @param {?} idSistema
     * @param {?} idDialog
     * @param {?} idLabel
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumento(idSistema, idDialog, idLabel, identificador = null, enabled = null) {
        /** @type {?} */
        var obj = { IdSistema: idSistema, Identificador: identificador, Enabled: enabled };
        /** @type {?} */
        var objJson = JSON.stringify(obj);
        /** @type {?} */
        var objBase64 = btoa(objJson);
        return objBase64;
    }
    /**
     * @param {?} idSistemas
     * @param {?} idDialog
     * @param {?} idLabel
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumentoListIdSistema(idSistemas, idDialog, idLabel, identificador = null, enabled = null) {
        /** @type {?} */
        var obj = { IdSistemas: idSistemas, Identificador: identificador, Enabled: enabled };
        /** @type {?} */
        var objJson = JSON.stringify(obj);
        /** @type {?} */
        var objBase64 = btoa((objJson));
        return objBase64;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} tramites
     * @param {?} codSistema
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} codPais
     * @param {?} codOficina
     * @return {?}
     */
    UploadTramitesDocumento(userId, userName, tramites, codSistema, idDocumento, documento, codPais, codOficina) {
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFilesTramites(tramites);
        /** @type {?} */
        let folderFiles = Mapper.ConvertListObject(tramites, new FolderFilesRequestVm());
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, folderFiles);
        }
        /** @type {?} */
        let filetype = DocumentoRequestVm.GetDocumentoRequestVm(idDocumento, documento);
        /** @type {?} */
        let documentos = [filetype];
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, documentos);
        return datosEnvio;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} documentoDtos
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @param {?=} idDialog
     * @param {?=} idLabel
     * @return {?}
     */
    UploadDocumentos(userId, userName, documentoDtos, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "", idDialog = "", idLabel = "") {
        this.Respuestas = [];
        //this.dialogService.Snniper();
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFiles(idSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion);
        /** @type {?} */
        var folderFile = FolderFilesRequestVm.GetFolderFilesRequestVm(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion);
        /** @type {?} */
        var listFolderFile = [folderFile];
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, documentoDtos);
        console.log(JSON.stringify(datosEnvio));
        return datosEnvio;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @param {?=} idDialog
     * @param {?=} idLabel
     * @return {?}
     */
    UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "", idDialog = "", idLabel = "") {
        this.Respuestas = [];
        //this.dialogService.Snniper();
        this.Verificar(codSistema, userId, userName);
        this.VerificarFolderFiles(idSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion);
        /** @type {?} */
        var folderFile = FolderFilesRequestVm.GetFolderFilesRequestVm(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion);
        /** @type {?} */
        var listFolderFile = [folderFile];
        /** @type {?} */
        var folder = new FolderRequestVm();
        if (codPais !== "" && codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        else if (codPais !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "504");
        }
        else if (codOficina !== "") {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile, "", "PRINC");
        }
        else {
            folder = FolderRequestVm.GetFolderRequestVm(codSistema, userId, userName, listFolderFile);
        }
        /** @type {?} */
        var documentos = DocumentoRequestVm.GetDocumentoRequestVm(idDocumento, documento);
        /** @type {?} */
        var listDocumentos = [documentos];
        /** @type {?} */
        var datosEnvio = DataRequest.GetDataRequest(folder, listDocumentos);
        console.log(JSON.stringify(datosEnvio));
        return datosEnvio;
    }
    /**
     * @param {?} folderFile
     * @return {?}
     */
    UpdateIdSistemaFolderFile(folderFile) {
        return this.callHttp.httpPost(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/PostUpdateFolderFile`, folderFile, { withCredentials: false });
    }
    /**
     * @param {?} idSistema
     * @return {?}
     */
    GetRespuestaUploadDocumento(idSistema) {
        if (this.Respuestas.Enumerable().any((/**
         * @param {?} a
         * @return {?}
         */
        a => a.IdSistema === idSistema && a.Save))) {
            /** @type {?} */
            let resp = this.Respuestas.Enumerable().lastOrDefault((/**
             * @param {?} f
             * @return {?}
             */
            f => f.IdSistema === idSistema && f.Save));
            if (resp !== null) {
                /** @type {?} */
                let call = this.callHttp
                    .httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=${resp.IdRespuesta}`, null, { withCredentials: false });
                call.subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    if (response != undefined) {
                        /** @type {?} */
                        let respTemp = response.Enumerable().firstOrDefault();
                        if (respTemp !== null) {
                            if (response.Enumerable().select((/**
                             * @param {?} s
                             * @return {?}
                             */
                            s => s.Estado)).firstOrDefault() === 1) {
                                resp.Save = true;
                            }
                        }
                    }
                    else {
                        console.log("Upload respuesta vacia 1");
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    //this.dialogService.SnniperClose();
                }));
                return call;
            }
            else {
                return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=null`, null, { withCredentials: false });
            }
        }
        else {
            /** @type {?} */
            let resp = this.Respuestas.Enumerable().lastOrDefault((/**
             * @param {?} f
             * @return {?}
             */
            f => f.IdSistema === idSistema));
            if (resp !== null) {
                /** @type {?} */
                let call = this.callHttp
                    .httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=${resp.IdRespuesta}`, null, { withCredentials: false });
                call.subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    if (response != undefined) {
                        /** @type {?} */
                        let respTemp = response.Enumerable().firstOrDefault();
                        if (respTemp !== null) {
                            if (response.Enumerable().select((/**
                             * @param {?} s
                             * @return {?}
                             */
                            s => s.Estado)).firstOrDefault() === 1) {
                                resp.Save = true;
                            }
                        }
                    }
                    else {
                        console.log("Upload respuesta vacia 2");
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    // void
                }));
                return call;
            }
            else {
                return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetResponseFileShare?id=null`, null, { withCredentials: false });
            }
        }
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFile(id) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFile`, { id: id }, { withCredentials: false });
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFileDownload(id) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFileDownload`, { id: id }, { withCredentials: false });
    }
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @return {?}
     */
    GetUrlFolderFileDownloadIdentificador(idSistema, identificador) {
        return this.callHttp.httpGetParams(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFileDownloadIdentificador`, { idSistema: idSistema, identificador: identificador }, { withCredentials: false });
    }
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @return {?}
     */
    GetUrlFolderFileDownloadTipoDocumento(idSistema, identificador) {
        return this.callHttp.httpPost(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetUrlFolderFileDownloadIdentificador`, [{ IdSistema: idSistema, TipoDocumento: identificador }], { withCredentials: false });
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    DeleteFile(ids) {
        return this.callHttp.httpPostText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/PostDeleteFolderFile`, ids, { withCredentials: false });
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    UpdateIdentificadorFolderFiles(ids) {
        return this.callHttp.httpPostText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/UpdateIdentificadorFolderFiles`, ids, { withCredentials: false });
    }
    /**
     * @return {?}
     */
    Upload() {
        this.dialogService.NotificacionAlert("Error CodSistema");
    }
    /**
     * @return {?}
     */
    GetNameFileSystem() {
        return this.callHttp.httpGetText(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetNameFileSystem`, null, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} codPais
     * @param {?} pais
     * @param {?} codOficina
     * @param {?} oficina
     * @param {?} sistema
     * @param {?} userId
     * @param {?} userName
     * @param {?} folderUriBase
     * @return {?}
     */
    GetFolder(codPais, pais, codOficina, oficina, sistema, userId, userName, folderUriBase) {
        return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetFolderUriByConditions`, `codPais=${codPais}&pais=${pais}&codOficina=${codOficina}&oficina=${oficina}&sistema=${sistema}&userId=${userId}&userName=${userName}&folderUriBase=${folderUriBase}`, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} codSistema
     * @param {?} codPais
     * @param {?} oficina
     * @param {?} codOficina
     * @param {?} userName
     * @param {?} userId
     * @param {?} fileExtension
     * @return {?}
     */
    GetFolderUrlSinged(codSistema, codPais, oficina, codOficina, userName, userId, fileExtension) {
        return this.callHttp.httpGet(`${this.fileShareWebApi}/Api/SyncFolderFilesApi/GetFolderUrlSinged`, `codSistema=${codSistema}&codPais=${codPais}&oficina=${oficina}&codOficina=${codOficina}&userName=${userName}&userId=${userId}&fileExtension=${fileExtension}`, { withCredentials: false }).toPromise();
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?} fileName
     * @param {?} fileExtension
     * @param {?} documentoBlob
     * @param {?} numeroReferencia
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentoBlob(userId, userName, idDocumento, documento, idSistema, codSistema, fileName, fileExtension, documentoBlob, numeroReferencia, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let promise = new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                /** @type {?} */
                let datoUpload = this.UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
                if (Strings.IsNullOrEmpty(fileExtension) || Strings.IsNullOrEmpty(numeroReferencia) || Strings.IsNullOrEmpty(fileName))
                    throw "fileExtension, numeroReferencia, fileName son campos obligatorios";
                if (documentoBlob == null)
                    throw "Documento Blob vacio";
                /** @type {?} */
                let folder = datoUpload.FolderRequestVm;
                /** @type {?} */
                let upload = yield this.GetFolderUrlSinged(folder.CodSistema, folder.CodPais, folder.Oficina, folder.CodOficina, folder.UserName, folder.UserId, fileExtension);
                let [folderFile] = folder.FolderFilesRequestVm;
                /** @type {?} */
                let documentoBto = { IdDocumento: idDocumento, NombreDocumento: documento, NumeroReferencia: numeroReferencia };
                /** @type {?} */
                let folderFileUpload = FolderFileBto.GetFolderFileBto(folderFile.IdSistema, folderFile.Identificador, folderFile.NombreEmpresa, folderFile.CodPaisOperacion, folderFile.Observacion, fileName, fileExtension, upload.NameFileSystem, documentoBlob.size, [documentoBto]);
                /** @type {?} */
                let folderUpload = FolderBto.GetFolderBto(folder.CodPais, folder.CodOficina, folder.Oficina, parseInt(folder.CodSistema), folder.UserName, parseInt(folder.UserId), [folderFileUpload]);
                this.callHttp.httpPutFileShare(upload.Url, documentoBlob, documentoBlob.type).subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                response => {
                    console.log("Documento Digitalizado");
                    console.log(response);
                    this.callHttp.httpPost(`${this.fileShareWebApi}/api/SyncFolderFilesApi/PostSaveDocument`, folderUpload, { withCredentials: false })
                        .subscribe((/**
                     * @param {?} response
                     * @return {?}
                     */
                    response => {
                        this.dialogService.NotificacionSucess("Documento Digitalizado con exito...");
                        resolve(response);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        this.dialogService.NotificacionAlert(error);
                        reject([]);
                    }));
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this.dialogService.NotificacionAlert(error);
                    reject([]);
                }));
            })));
            return promise;
        });
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?} documentosBlob
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentoListBlob(userId, userName, idSistema, codSistema, documentosBlob, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        //let promise = new Promise<Array<ReponseUploadFileBlob>>(async (resolve, reject) => {
        /** @type {?} */
        let subject = new Subject();
        if (!Array.isArray(documentosBlob))
            throw "Documentos vacio";
        if (documentosBlob.some((/**
         * @param {?} s
         * @return {?}
         */
        s => Strings.IsNullOrEmpty(s.FileExtension) || Strings.IsNullOrEmpty(s.NumeroReferencia) || Strings.IsNullOrEmpty(s.FileName))))
            throw "fileExtension, numeroReferencia, fileName son campos obligatorios";
        if (documentosBlob.some((/**
         * @param {?} s
         * @return {?}
         */
        s => s.File == null)))
            throw "Documento Blob vacio";
        /** @type {?} */
        let uploadResponseDocumentos = [];
        documentosBlob.forEach((/**
         * @param {?} f
         * @param {?} i
         * @return {?}
         */
        (f, i) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let datoUpload = this.UploadDocumento(userId, userName, f.IdDocumento, f.Documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
            /** @type {?} */
            let folder = datoUpload.FolderRequestVm;
            /** @type {?} */
            let upload = yield this.GetFolderUrlSinged(folder.CodSistema, folder.CodPais, folder.Oficina, folder.CodOficina, folder.UserName, folder.UserId, f.FileExtension);
            let [folderFile] = folder.FolderFilesRequestVm;
            /** @type {?} */
            let documentoBto = { IdDocumento: f.IdDocumento, NombreDocumento: f.Documento, NumeroReferencia: f.NumeroReferencia };
            /** @type {?} */
            let folderFileUpload = FolderFileBto.GetFolderFileBto(folderFile.IdSistema, folderFile.Identificador, folderFile.NombreEmpresa, folderFile.CodPaisOperacion, folderFile.Observacion, f.FileName, f.FileExtension, upload.NameFileSystem, f.File.size, [documentoBto]);
            /** @type {?} */
            let folderUpload = FolderBto.GetFolderBto(folder.CodPais, folder.CodOficina, folder.Oficina, parseInt(folder.CodSistema), folder.UserName, parseInt(folder.UserId), [folderFileUpload]);
            try {
                //let responseUpload = await this.callHttp.httpPutFileShareProgress(upload.Url, f.File, f.File.type).toPromise()
                this.callHttp.httpPutFileShareProgress(upload.Url, f.File, f.File.type).subscribe((/**
                 * @param {?} event
                 * @return {?}
                 */
                event => {
                    switch (event.type) {
                        case HttpEventType.Sent:
                            console.log('Request has been made!');
                            break;
                        case HttpEventType.ResponseHeader:
                            console.log('Response header has been received!');
                            break;
                        case HttpEventType.UploadProgress:
                            /** @type {?} */
                            let progress = Math.round(event.loaded / event.total * 100);
                            console.log(`Uploaded! ${progress}%`);
                            subject.next({ Event: true, Data: { Index: i, Progress: progress } });
                            break;
                        case HttpEventType.Response:
                            console.log('User successfully created!', event.body);
                            setTimeout((/**
                             * @return {?}
                             */
                            () => {
                                //this.progress = 0;
                            }), 1500);
                    }
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    this.dialogService.NotificacionAlert(error);
                }), (/**
                 * @return {?}
                 */
                () => __awaiter(this, void 0, void 0, function* () {
                    console.log("Documento Digitalizado");
                    //console.log(responseUpload);
                    /** @type {?} */
                    let response = yield this.callHttp.httpPost(`${this.fileShareWebApi}/api/SyncFolderFilesApi/PostSaveDocument`, folderUpload, { withCredentials: false }).toPromise();
                    let [uploadDocumento] = response;
                    if (uploadDocumento != null) {
                        uploadDocumento.NumeroReferencia = f.NumeroReferencia;
                        uploadResponseDocumentos.push(uploadDocumento);
                        this.dialogService.NotificacionSucess(`Documento ${f.NumeroReferencia}, Digitalizado con exito...`);
                    }
                    if (uploadResponseDocumentos.length == documentosBlob.length) {
                        subject.next({ Event: false, Data: uploadResponseDocumentos });
                        subject.complete();
                    }
                })));
            }
            catch (error) {
                this.dialogService.NotificacionAlert(error);
            }
        })));
        //resolve(uploadResponseDocumentos)
        //})
        return subject;
        //return promise;
    }
    /**
     * @param {?} base64Data
     * @param {?} contentType
     * @return {?}
     */
    Base64toBlob(base64Data, contentType) {
        document.getElementById("status").innerHTML += "Processing file</br>";
        contentType = contentType || '';
        /** @type {?} */
        var sliceSize = 1024;
        /** @type {?} */
        var byteCharacters = atob(base64Data);
        /** @type {?} */
        var bytesLength = byteCharacters.length;
        /** @type {?} */
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        /** @type {?} */
        var byteArrays = new Array(slicesCount);
        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            /** @type {?} */
            var begin = sliceIndex * sliceSize;
            /** @type {?} */
            var end = Math.min(begin + sliceSize, bytesLength);
            /** @type {?} */
            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    /**
     * @private
     * @param {?} codSistema
     * @param {?} userId
     * @param {?} userName
     * @return {?}
     */
    Verificar(codSistema, userId, userName) {
        if (Strings.IsNullOrEmpty(codSistema) || Strings.IsNullOrEmpty(userId) || Strings.IsNullOrEmpty(userName)) {
            throw "CodSistema, UserId, userName son campos obligatorios";
        }
    }
    /**
     * @private
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @return {?}
     */
    VerificarFolderFiles(idSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "") {
        if (!Strings.IsNullOrEmpty(idSistema)) {
            if (Strings.IsNullOrEmpty(identificador) && Strings.IsNullOrEmpty(nombreEmpresa) &&
                Strings.IsNullOrEmpty(codPaisOperacion) && Strings.IsNullOrEmpty(datos) &&
                Strings.IsNullOrEmpty(observacion)) {
                throw "Tramites no cumplen con requisitos minimos. IdSistema es campo obligatorio. Identificador, " +
                    "NombreEmpresa, Datos, CodPaisOperacion, Observacion, se debe tener al menos uno de ellos";
            }
        }
        else {
            throw "IdSistema es campo obligatorio";
        }
    }
    /**
     * @private
     * @param {?} tramites
     * @return {?}
     */
    VerificarFolderFilesTramites(tramites) {
        /** @type {?} */
        let folderFilesTemp = [];
        /** @type {?} */
        let folderFiles = tramites.Enumerable();
        folderFiles.forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            if (!Strings.IsNullOrEmpty(f.IdSistema)) {
                if (Strings.IsNullOrEmpty(f.Identificador) && Strings.IsNullOrEmpty(f.Datos) &&
                    Strings.IsNullOrEmpty(f.NombreEmpresa) && Strings.IsNullOrEmpty(f.Observacion) &&
                    Strings.IsNullOrEmpty(f.CodPaisOperacion)) {
                    folderFilesTemp.push(f);
                }
            }
            else {
                folderFilesTemp.push(f);
            }
        }));
        if (folderFilesTemp.Enumerable().any()) {
            throw "Tramites no cumplen con requisitos minimos. " +
                "IdSistema es campo obligatorio. Identificador, NombreEmpresa, Datos, " +
                "CodPaisOperacion, Observacion se debe tener al menos uno de ellos";
        }
    }
}
FileshareService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FileshareService.ctorParameters = () => [
    { type: DialogService },
    { type: CallHttp },
    { type: String, decorators: [{ type: Inject, args: [FILESHARE_API,] }] }
];
/** @nocollapse */ FileshareService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FileshareService_Factory() { return new FileshareService(ɵɵinject(DialogService), ɵɵinject(CallHttp), ɵɵinject(FILESHARE_API)); }, token: FileshareService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FileshareService.prototype.Respuestas;
    /**
     * @type {?}
     * @private
     */
    FileshareService.prototype.dialogService;
    /**
     * @type {?}
     * @private
     */
    FileshareService.prototype.callHttp;
    /**
     * @type {?}
     * @private
     */
    FileshareService.prototype.fileShareWebApi;
}
class DocumentoRequestVm {
    constructor() {
        this.IdDocumento = 0;
        this.Documento = "";
    }
    /**
     * @param {?} idDocumento
     * @param {?} documento
     * @return {?}
     */
    static GetDocumentoRequestVm(idDocumento, documento) {
        /** @type {?} */
        var obj = new DocumentoRequestVm();
        obj.IdDocumento = idDocumento;
        obj.Documento = documento;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    DocumentoRequestVm.prototype.IdDocumento;
    /** @type {?} */
    DocumentoRequestVm.prototype.Documento;
}
class FolderFilesRequestVm {
    constructor() {
        this.Id = 0;
        this.IdFolder = 0;
        this.IdSistema = null;
        this.Identificador = null;
        this.NombreEmpresa = null;
        this.Datos = null;
        this.CodPaisOperacion = null;
        this.Observacion = null;
    }
    /**
     * @param {?} idSistema
     * @param {?=} identidificador
     * @param {?=} nombreEmpresa
     * @param {?=} datos
     * @param {?=} codPaisOperacion
     * @param {?=} observacion
     * @return {?}
     */
    static GetFolderFilesRequestVm(idSistema, identidificador = "", nombreEmpresa = "", datos = "", codPaisOperacion = "", observacion = "") {
        /** @type {?} */
        var obj = new FolderFilesRequestVm();
        obj.IdSistema = idSistema;
        obj.Identificador = identidificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.Datos = datos;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Observacion = observacion;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderFilesRequestVm.prototype.Id;
    /** @type {?} */
    FolderFilesRequestVm.prototype.IdFolder;
    /** @type {?} */
    FolderFilesRequestVm.prototype.IdSistema;
    /** @type {?} */
    FolderFilesRequestVm.prototype.Identificador;
    /** @type {?} */
    FolderFilesRequestVm.prototype.NombreEmpresa;
    /** @type {?} */
    FolderFilesRequestVm.prototype.Datos;
    /** @type {?} */
    FolderFilesRequestVm.prototype.CodPaisOperacion;
    /** @type {?} */
    FolderFilesRequestVm.prototype.Observacion;
}
/**
 * @record
 */
function FolderVm() { }
if (false) {
    /** @type {?} */
    FolderVm.prototype.Id;
    /** @type {?} */
    FolderVm.prototype.CodPais;
    /** @type {?} */
    FolderVm.prototype.Pais;
    /** @type {?} */
    FolderVm.prototype.CodOficina;
    /** @type {?} */
    FolderVm.prototype.Oficina;
    /** @type {?} */
    FolderVm.prototype.Sistema;
    /** @type {?} */
    FolderVm.prototype.FolderUri;
    /** @type {?} */
    FolderVm.prototype.CreatedBy;
    /** @type {?} */
    FolderVm.prototype.Created;
    /** @type {?} */
    FolderVm.prototype.Enabled;
    /** @type {?} */
    FolderVm.prototype.UserName;
    /** @type {?} */
    FolderVm.prototype.Sync;
    /** @type {?} */
    FolderVm.prototype.SyncDate;
}
class FolderRequestVm {
    constructor() {
        this.Id = 0;
        this.CodPais = "504";
        this.CodOficina = "PRINC";
        this.Oficina = "Principal";
        this.CodSistema = "";
        this.UserId = "";
        this.UserName = "";
        this.FolderFilesRequestVm = [];
    }
    /**
     * @param {?} codSistema
     * @param {?} userId
     * @param {?} userName
     * @param {?} folderFile
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    static GetFolderRequestVm(codSistema, userId, userName, folderFile, codPais = "", codOficina = "") {
        /** @type {?} */
        var obj = new FolderRequestVm();
        obj.CodSistema = codSistema;
        obj.UserId = userId;
        obj.UserName = userName;
        obj.FolderFilesRequestVm = folderFile;
        if (codOficina !== "") {
            obj.CodOficina = codOficina;
        }
        if (codPais !== "") {
            obj.CodPais = codPais;
        }
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderRequestVm.prototype.Id;
    /** @type {?} */
    FolderRequestVm.prototype.CodPais;
    /** @type {?} */
    FolderRequestVm.prototype.CodOficina;
    /** @type {?} */
    FolderRequestVm.prototype.Oficina;
    /** @type {?} */
    FolderRequestVm.prototype.CodSistema;
    /** @type {?} */
    FolderRequestVm.prototype.UserId;
    /** @type {?} */
    FolderRequestVm.prototype.UserName;
    /** @type {?} */
    FolderRequestVm.prototype.FolderFilesRequestVm;
}
class DataRequest {
    constructor() {
        this.FolderRequestVm = new FolderRequestVm();
        this.DocumentoRequestVm = [];
    }
    /**
     * @param {?} folderRequestVm
     * @param {?} documentoRequestVm
     * @return {?}
     */
    static GetDataRequest(folderRequestVm, documentoRequestVm) {
        /** @type {?} */
        var obj = new DataRequest();
        obj.FolderRequestVm = folderRequestVm;
        obj.DocumentoRequestVm = documentoRequestVm;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    DataRequest.prototype.FolderRequestVm;
    /** @type {?} */
    DataRequest.prototype.DocumentoRequestVm;
}
class RespuestaDataRequest {
    constructor() {
        this.IdFolderRequest = 0;
        this.IdDocumento = [];
    }
    /**
     * @param {?} idFolderRequest
     * @param {?} IdDocumento
     * @return {?}
     */
    static GetRespuestaDataRequest(idFolderRequest, IdDocumento) {
        /** @type {?} */
        var obj = new RespuestaDataRequest();
        obj.IdDocumento = IdDocumento;
        obj.IdFolderRequest = idFolderRequest;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    RespuestaDataRequest.prototype.IdFolderRequest;
    /** @type {?} */
    RespuestaDataRequest.prototype.IdDocumento;
}
class FolderFileUpdateIdentificadorVm {
    /**
     * @param {?} id
     * @param {?} identificador
     * @return {?}
     */
    static GetFolderFileUpdateIdentificadorVm(id, identificador) {
        /** @type {?} */
        let obj = {
            Id: id,
            Identificador: identificador
        };
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderFileUpdateIdentificadorVm.prototype.Id;
    /** @type {?} */
    FolderFileUpdateIdentificadorVm.prototype.Identificador;
}
class ResponseFileShareVm {
    constructor() {
        this.IdSistema = "";
        this.Estado = EstadoReponseFileShare.Start;
        this.DocumentoResponseVms = [];
    }
}
if (false) {
    /** @type {?} */
    ResponseFileShareVm.prototype.IdSistema;
    /** @type {?} */
    ResponseFileShareVm.prototype.Estado;
    /** @type {?} */
    ResponseFileShareVm.prototype.IdFolderFile;
    /** @type {?} */
    ResponseFileShareVm.prototype.DocumentoResponseVms;
}
/**
 * @record
 */
function FolderFileDownloadVm() { }
if (false) {
    /** @type {?} */
    FolderFileDownloadVm.prototype.Url;
    /** @type {?|undefined} */
    FolderFileDownloadVm.prototype.FileName;
    /** @type {?} */
    FolderFileDownloadVm.prototype.MimeType;
}
/** @enum {number} */
const EstadoReponseFileShare = {
    Start: -1,
    NoLoaded: 0,
    Upload: 1,
};
EstadoReponseFileShare[EstadoReponseFileShare.Start] = 'Start';
EstadoReponseFileShare[EstadoReponseFileShare.NoLoaded] = 'NoLoaded';
EstadoReponseFileShare[EstadoReponseFileShare.Upload] = 'Upload';
class ResponseFileShare {
    constructor() {
        this.IdSistema = "";
        this.IdRespuesta = 0;
        this.Save = false;
    }
    /**
     * @param {?} idSistema
     * @param {?} idRespuesta
     * @return {?}
     */
    static GetResponseFileShare(idSistema, idRespuesta) {
        /** @type {?} */
        var obj = new ResponseFileShare();
        obj.IdRespuesta = idRespuesta;
        obj.IdSistema = idSistema;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    ResponseFileShare.prototype.IdSistema;
    /** @type {?} */
    ResponseFileShare.prototype.IdRespuesta;
    /** @type {?} */
    ResponseFileShare.prototype.Save;
}
class ResponseFileShareHojasRutas {
    constructor() {
        this.IdSistemas = [];
        this.IdRespuesta = 0;
        this.Save = false;
    }
    /**
     * @param {?} idSistema
     * @param {?} idRespuesta
     * @return {?}
     */
    static GetResponseFileShare(idSistema, idRespuesta) {
        /** @type {?} */
        var obj = new ResponseFileShareHojasRutas();
        obj.IdRespuesta = idRespuesta;
        obj.IdSistemas = idSistema;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    ResponseFileShareHojasRutas.prototype.IdSistemas;
    /** @type {?} */
    ResponseFileShareHojasRutas.prototype.IdRespuesta;
    /** @type {?} */
    ResponseFileShareHojasRutas.prototype.Save;
}
class DocumentoResponseVm {
    constructor() {
        this.IdDocumento = 0;
        this.Documento = "";
        this.NoReferencia = "";
    }
}
if (false) {
    /** @type {?} */
    DocumentoResponseVm.prototype.IdDocumento;
    /** @type {?} */
    DocumentoResponseVm.prototype.Documento;
    /** @type {?} */
    DocumentoResponseVm.prototype.NoReferencia;
}
class Strings extends String {
    /**
     * @param {?} value
     * @return {?}
     */
    static IsNullOrEmpty(value) {
        /** @type {?} */
        var isNullOrEmpty = true;
        if (value) {
            if (typeof (value) === "string") {
                if (value.length > 0) {
                    isNullOrEmpty = false;
                }
            }
        }
        return isNullOrEmpty;
    }
}
class TramiteInfo {
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @param {?} nombreEmpresa
     * @param {?} datos
     * @param {?} codPaisOperacion
     * @param {?} observacion
     * @return {?}
     */
    static GetTramiteInfo(idSistema, identificador, nombreEmpresa, datos, codPaisOperacion, observacion) {
        /** @type {?} */
        let obj = new TramiteInfo();
        obj.IdSistema = idSistema;
        obj.Identificador = identificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.Datos = datos;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Observacion = observacion;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    TramiteInfo.prototype.IdSistema;
    /** @type {?} */
    TramiteInfo.prototype.Identificador;
    /** @type {?} */
    TramiteInfo.prototype.NombreEmpresa;
    /** @type {?} */
    TramiteInfo.prototype.Datos;
    /** @type {?} */
    TramiteInfo.prototype.CodPaisOperacion;
    /** @type {?} */
    TramiteInfo.prototype.Observacion;
}
class FolderFileVmGroup {
    /**
     * @param {?} idSistema
     * @param {?} ids
     * @return {?}
     */
    static GetFolderFileVmGroup(idSistema, ids) {
        /** @type {?} */
        let obj = new FolderFileVmGroup();
        obj.Ids = ids;
        obj.IdSistema = idSistema;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderFileVmGroup.prototype.IdSistema;
    /** @type {?} */
    FolderFileVmGroup.prototype.Ids;
}
/**
 * @record
 */
function ResponseFolderUpload() { }
if (false) {
    /** @type {?} */
    ResponseFolderUpload.prototype.NameFileSystem;
    /** @type {?} */
    ResponseFolderUpload.prototype.Url;
}
class DocumentoBto {
}
if (false) {
    /** @type {?} */
    DocumentoBto.prototype.IdDocumento;
    /** @type {?} */
    DocumentoBto.prototype.NombreDocumento;
    /** @type {?} */
    DocumentoBto.prototype.NumeroReferencia;
}
class FolderFileBto {
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @param {?} nombreEmpresa
     * @param {?} codPaisOperacion
     * @param {?} observacion
     * @param {?} fileName
     * @param {?} fileExtencion
     * @param {?} fileNameSystem
     * @param {?} fileSize
     * @param {?} documentoBto
     * @return {?}
     */
    static GetFolderFileBto(idSistema, identificador, nombreEmpresa, codPaisOperacion, observacion, fileName, fileExtencion, fileNameSystem, fileSize, documentoBto) {
        /** @type {?} */
        let obj = {
            IdSistema: idSistema,
            Identificador: identificador,
            NombreEmpresa: nombreEmpresa,
            CodPaisOperacion: codPaisOperacion,
            Observacion: observacion,
            FileName: fileName,
            FileNameSystem: fileNameSystem,
            FileExtencion: fileExtencion,
            FileSize: fileSize,
            DocumentoBto: documentoBto
        };
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderFileBto.prototype.IdSistema;
    /** @type {?} */
    FolderFileBto.prototype.Identificador;
    /** @type {?} */
    FolderFileBto.prototype.NombreEmpresa;
    /** @type {?} */
    FolderFileBto.prototype.CodPaisOperacion;
    /** @type {?} */
    FolderFileBto.prototype.Observacion;
    /** @type {?} */
    FolderFileBto.prototype.FileName;
    /** @type {?} */
    FolderFileBto.prototype.FileExtencion;
    /** @type {?} */
    FolderFileBto.prototype.FileNameSystem;
    /** @type {?} */
    FolderFileBto.prototype.FileSize;
    /** @type {?} */
    FolderFileBto.prototype.DocumentoBto;
}
class FolderBto {
    /**
     * @param {?} codPais
     * @param {?} codOficina
     * @param {?} oficina
     * @param {?} codSistema
     * @param {?} userName
     * @param {?} userId
     * @param {?} folderFileBto
     * @return {?}
     */
    static GetFolderBto(codPais, codOficina, oficina, codSistema, userName, userId, folderFileBto) {
        /** @type {?} */
        let obj = {
            CodPais: codPais,
            CodOficina: codOficina,
            Oficina: oficina,
            CodSistema: codSistema,
            UserName: userName,
            UserId: userId,
            FolderFileBto: folderFileBto
        };
        return obj;
    }
}
if (false) {
    /** @type {?} */
    FolderBto.prototype.CodPais;
    /** @type {?} */
    FolderBto.prototype.CodOficina;
    /** @type {?} */
    FolderBto.prototype.Oficina;
    /** @type {?} */
    FolderBto.prototype.CodSistema;
    /** @type {?} */
    FolderBto.prototype.UserName;
    /** @type {?} */
    FolderBto.prototype.UserId;
    /** @type {?} */
    FolderBto.prototype.FolderFileBto;
}
/**
 * @record
 */
function ReponseUploadFileBlob() { }
if (false) {
    /** @type {?} */
    ReponseUploadFileBlob.prototype.IdSistema;
    /** @type {?} */
    ReponseUploadFileBlob.prototype.Id;
    /** @type {?} */
    ReponseUploadFileBlob.prototype.NumeroReferencia;
}
class UploadMultiple {
    constructor() {
        this.Documentos = [];
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idSistema
     * @param {?} codigoSistema
     * @param {?} documentos
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    static getUploadMultiple(userId, userName, idSistema, codigoSistema, documentos, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina) {
        /** @type {?} */
        let obj = new UploadMultiple();
        obj.UserId = userId;
        obj.UserName = userName;
        obj.IdSistema = idSistema;
        obj.CodigoSistema = codigoSistema;
        obj.Documentos = documentos;
        obj.Identificador = identificador;
        obj.NombreEmpresa = nombreEmpresa;
        obj.CodPaisOperacion = codPaisOperacion;
        obj.Datos = datos;
        obj.Observacion = observacion;
        obj.CodPais = codPais;
        obj.CodOficina = codOficina;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    UploadMultiple.prototype.UserId;
    /** @type {?} */
    UploadMultiple.prototype.UserName;
    /** @type {?} */
    UploadMultiple.prototype.IdSistema;
    /** @type {?} */
    UploadMultiple.prototype.CodigoSistema;
    /** @type {?} */
    UploadMultiple.prototype.Documentos;
    /** @type {?} */
    UploadMultiple.prototype.Identificador;
    /** @type {?} */
    UploadMultiple.prototype.NombreEmpresa;
    /** @type {?} */
    UploadMultiple.prototype.CodPaisOperacion;
    /** @type {?} */
    UploadMultiple.prototype.Datos;
    /** @type {?} */
    UploadMultiple.prototype.Observacion;
    /** @type {?} */
    UploadMultiple.prototype.CodPais;
    /** @type {?} */
    UploadMultiple.prototype.CodOficina;
}
class DocumentoBlob {
    /**
     * @param {?} file
     * @param {?} numeroReferencia
     * @param {?} fileName
     * @param {?} fileExtension
     * @param {?} idDocumento
     * @param {?} documento
     * @return {?}
     */
    static getDocumentosBlob(file, numeroReferencia, fileName, fileExtension, idDocumento, documento) {
        /** @type {?} */
        let obj = new DocumentoBlob();
        obj.File = file;
        obj.NumeroReferencia = numeroReferencia;
        obj.FileName = fileName;
        obj.FileExtension = fileExtension;
        obj.IdDocumento = idDocumento;
        obj.Documento = documento;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    DocumentoBlob.prototype.File;
    /** @type {?} */
    DocumentoBlob.prototype.NumeroReferencia;
    /** @type {?} */
    DocumentoBlob.prototype.FileName;
    /** @type {?} */
    DocumentoBlob.prototype.FileExtension;
    /** @type {?} */
    DocumentoBlob.prototype.IdDocumento;
    /** @type {?} */
    DocumentoBlob.prototype.Documento;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = require("chance").Chance();
class FileshareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} dialogService
     * @param {?} callHttp
     * @param {?} fileShareWeb
     * @param {?} fileShareApi
     */
    constructor(fileShareService, dialogService, callHttp, fileShareWeb, fileShareApi) {
        this.fileShareService = fileShareService;
        this.dialogService = dialogService;
        this.callHttp = callHttp;
        this.fileShareWeb = fileShareWeb;
        this.fileShareApi = fileShareApi;
    }
    /**
     * @return {?}
     */
    get tittle() {
        return this._tittle;
    }
    /**
     * @return {?}
     */
    get width() {
        return this._width;
    }
    /**
     * @return {?}
     */
    get height() {
        return this._height;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.IdDialog = chance.guid();
        this.IdLabel = chance.guid();
        this._tittle = "Upload Files";
        this._width = "850";
    }
    /**
     * @return {?}
     */
    Close() {
        if (this.IdInstrucion !== undefined) {
            this.SubjectModal.next(this.IdInstrucion);
        }
        else if (this.IdInstrucciones !== undefined) {
            this.SubjectModalList.next(this.IdInstrucciones);
        }
    }
    /**
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadDocumento(idSistema, identificador = null, enabled = true) {
        this.SubjectModal = new Subject();
        //this.IdInstrucion = idSistema;
        /** @type {?} */
        var objBase64 = this.fileShareService.DownloadDocumento(idSistema, this.IdDialog, this.IdLabel, identificador, enabled);
        this._tittle = "Download Files";
        this._width = "500";
        /** @type {?} */
        var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareDloadClienteSide&datos=${objBase64}`;
        this._height = "505px";
        this.modelIframeComponent.showModal(url);
        return this.SubjectModal;
    }
    /**
     * @param {?} idSistema
     * @param {?=} identificador
     * @param {?=} enabled
     * @return {?}
     */
    DownloadListDocumento(idSistema, identificador = null, enabled = true) {
        this.SubjectModal = new Subject();
        // this.IdInstrucion = idSistema;
        /** @type {?} */
        var objBase64 = this.fileShareService.DownloadDocumentoListIdSistema(idSistema, this.IdDialog, this.IdLabel, identificador, enabled);
        this._tittle = "Download Files";
        this._width = "500";
        /** @type {?} */
        var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareDloadClienteSide&datos=${objBase64}`;
        this._height = "505px";
        this.modelIframeComponent.showModal(url);
        return this.SubjectModal;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} documentosDtos
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumentos(userId, userName, documentosDtos, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        this.IdInstrucion = idSistema;
        this.SubjectModal = new Subject();
        /** @type {?} */
        let datosEnvio = this.fileShareService.UploadDocumentos(userId, userName, documentosDtos, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina);
        this._tittle = "Upload Files";
        this._width = "850";
        this._height = "480px";
        this.callHttp
            .httpPost(`${this.fileShareApi}/Api/SyncFolderFilesApi/PostDataRequest`, datosEnvio, { withCredentials: false }) // { withCredentials: false }
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response !== null) {
                this.fileShareService.Respuestas.push(ResponseFileShare.GetResponseFileShare(idSistema, response.IdFolderRequest));
                this.fileShareService.Respuestas.push();
                /** @type {?} */
                var jsonResult = JSON.stringify(response);
                /** @type {?} */
                var jsonBase64 = btoa(jsonResult);
                /** @type {?} */
                var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareUploadClientSide&datos=${jsonBase64}`;
                this.modelIframeComponent.showModal(url);
            }
            else {
                this.dialogService.NotificacionAlert("Fileshare: No se pudo obtener respuesta.");
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert("Fileshare: Error en la comunicación.");
        }));
        return this.SubjectModal;
    }
    /**
     * @param {?} userId
     * @param {?} userName
     * @param {?} idDocumento
     * @param {?} documento
     * @param {?} idSistema
     * @param {?} codSistema
     * @param {?=} identificador
     * @param {?=} nombreEmpresa
     * @param {?=} codPaisOperacion
     * @param {?=} datos
     * @param {?=} observacion
     * @param {?=} codPais
     * @param {?=} codOficina
     * @return {?}
     */
    UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador = "", nombreEmpresa = "", codPaisOperacion = "", datos = "", observacion = "", codPais = "", codOficina = "") {
        this.IdInstrucion = idSistema;
        this.SubjectModal = new Subject();
        /** @type {?} */
        var datosEnvio = this.fileShareService.UploadDocumento(userId, userName, idDocumento, documento, idSistema, codSistema, identificador, nombreEmpresa, codPaisOperacion, datos, observacion, codPais, codOficina, this.IdDialog, this.IdLabel);
        this._tittle = "Upload Files";
        this._width = "850px";
        this._height = "480px";
        this.callHttp.httpPost(`${this.fileShareApi}/Api/SyncFolderFilesApi/PostDataRequest`, datosEnvio, { withCredentials: false }) // { withCredentials: false }
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response !== null) {
                this.fileShareService.Respuestas
                    .push(ResponseFileShare.GetResponseFileShare(idSistema, response.IdFolderRequest));
                this.fileShareService.Respuestas.push();
                /** @type {?} */
                var jsonResult = JSON.stringify(response);
                /** @type {?} */
                var jsonBase64 = btoa(jsonResult);
                /** @type {?} */
                var url = `${this.fileShareWeb}/Default.aspx?pagina=FileShareUploadClientSide&datos=${jsonBase64}`;
                this.modelIframeComponent.showModal(url);
            }
            else {
                this.dialogService.NotificacionAlert("Fileshare: No se pudo obtener respuesta.");
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert("Fileshare: Error en la comunicación.");
        }));
        return this.SubjectModal;
    }
    /**
     * @param {?} hojaRuta
     * @return {?}
     */
    GetRespuestaUploadDocumento(hojaRuta) {
        return this.fileShareService.GetRespuestaUploadDocumento(hojaRuta);
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    DeleteFile(ids) {
        return this.fileShareService.DeleteFile(ids);
    }
    /**
     * @param {?} ids
     * @return {?}
     */
    UpdateIdentificadorFolderFiles(ids) {
        return this.fileShareService.UpdateIdentificadorFolderFiles(ids);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFile(id) {
        return this.fileShareService.GetUrlFolderFile(id);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    GetUrlFolderFileDownload(id) {
        this.fileShareService.GetUrlFolderFileDownload(id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.callHttp.httpGetFile(response.Url, response.FileName, { withCredentials: false }).subscribe((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
            }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
        }));
    }
    /**
     * @param {?} idSistema
     * @param {?} identificador
     * @return {?}
     */
    GetUrlFolderFileDownloadIdentificador(idSistema, identificador) {
        this.fileShareService.GetUrlFolderFileDownloadIdentificador(idSistema, identificador).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.callHttp.httpGetFile(response.Url, response.FileName, { withCredentials: false }).subscribe((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
            }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
        }));
    }
    /**
     * @param {?} idSistema
     * @param {?} tipoDocumento
     * @return {?}
     */
    GetUrlFolderFileDownloadTipoDocumento(idSistema, tipoDocumento) {
        this.fileShareService.GetUrlFolderFileDownloadTipoDocumento(idSistema, tipoDocumento).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            let [dataResponse] = response;
            this.callHttp.httpGetFile(dataResponse.Url, dataResponse.FileName, { withCredentials: false }).subscribe((/**
             * @return {?}
             */
            () => { }), (/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
            }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            this.dialogService.NotificacionAlert(`FileShare error: ${error}`);
        }));
    }
}
FileshareComponent.decorators = [
    { type: Component, args: [{
                //
                selector: 'fileshare',
                template: `<modal-iframe-template [tittle]="tittle" [width-modal]="'850px'" [height-modal]="height" (close)="Close()"></modal-iframe-template>`
            }] }
];
/** @nocollapse */
FileshareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: DialogService },
    { type: CallHttp },
    { type: String, decorators: [{ type: Inject, args: [FILESHARE_WEB,] }] },
    { type: String, decorators: [{ type: Inject, args: [FILESHARE_API,] }] }
];
FileshareComponent.propDecorators = {
    modelIframeComponent: [{ type: ViewChild, args: [ModalIframeComponent, { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.IdDialog;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.IdLabel;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.IdInstrucion;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.IdInstrucciones;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype._tittle;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype._width;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype._height;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.SubjectModal;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.SubjectModalList;
    /** @type {?} */
    FileshareComponent.prototype.modelIframeComponent;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.fileShareService;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.dialogService;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.callHttp;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.fileShareWeb;
    /**
     * @type {?}
     * @private
     */
    FileshareComponent.prototype.fileShareApi;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare/view-fileshare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ViewDocumentos(item) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            //let url = (tipo == 'image') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            /** @type {?} */
            let url = response.Url;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
    }
    /**
     * @return {?}
     */
    ShowModal() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.modal.showModal().subscribe((/**
             * @param {?} rseponse
             * @return {?}
             */
            rseponse => {
                this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
                resolve(true);
            }));
        }));
        return promise;
    }
}
ViewFileshareComponent.decorators = [
    { type: Component, args: [{
                selector: 'view-fileshare',
                template: "<modal-template #modalTemplate [width-modal]=\"'90%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells4\">\r\n      <div class=\"cell colspan2\">\r\n        <ng-select class=\"custom\" [items]=\"Documentos\" bindLabel=\"Descripcion\" (change)=\"ViewDocumentos($event)\"\r\n                   placeholder=\"Seleccione...\"></ng-select>\r\n      </div>\r\n    </div>\r\n    <div class=\"row cell\">\r\n      <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n    </div>\r\n  </div>\r\n</modal-template>`\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewFileshareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: DomSanitizer }
];
ViewFileshareComponent.propDecorators = {
    Documentos: [{ type: Input, args: ['documentos',] }],
    modal: [{ type: ViewChild, args: ['modalTemplate', { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ViewFileshareComponent.prototype._Url;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareComponent.prototype._mimeType;
    /** @type {?} */
    ViewFileshareComponent.prototype.Documentos;
    /** @type {?} */
    ViewFileshareComponent.prototype.modal;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareComponent.prototype.fileShareService;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare-content/view-fileshare-content.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareContentComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    ViewDocumentos(item) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            /** @type {?} */
            let url = response.Url;
            //let url = (tipo == 'image') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
    }
    /**
     * @return {?}
     */
    ShowModal() {
        this.modal.showModal().subscribe((/**
         * @param {?} rseponse
         * @return {?}
         */
        rseponse => {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        }));
    }
    /**
     * @return {?}
     */
    CloseModal() {
        this.modal.closeModal();
    }
}
ViewFileshareContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'view-fileshare-content',
                template: "<modal-template #modalTemplate [width-modal]=\"'90%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells4\">\r\n      <div class=\"cell colspan2\">\r\n        <ng-select class=\"custom\" [items]=\"Documentos\" bindLabel=\"Descripcion\" (change)=\"ViewDocumentos($event)\"\r\n                   placeholder=\"Seleccione...\"></ng-select>\r\n      </div>\r\n    </div>\r\n    <div class=\"row cells3\">\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n      <div class=\"cell\" style=\"max-height:63vh;\">\r\n        <div [ngClass]=\"{'contentDialog': isContentDinamico }\" style=\"height:63vh;\">\r\n          <ng-content class=\"contentDinamico\"></ng-content>\r\n        </div>        \r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [".contentDinamicoHeader .contentDinamico{border:0;width:100%;overflow-y:scroll;overflow-x:auto;overflow-wrap:normal}"]
            }] }
];
/** @nocollapse */
ViewFileshareContentComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: DomSanitizer }
];
ViewFileshareContentComponent.propDecorators = {
    isContentDinamico: [{ type: Input, args: ['isContentDinamico',] }],
    Documentos: [{ type: Input, args: ['documentos',] }],
    modal: [{ type: ViewChild, args: ['modalTemplate', { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ViewFileshareContentComponent.prototype._Url;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareContentComponent.prototype._mimeType;
    /** @type {?} */
    ViewFileshareContentComponent.prototype.isContentDinamico;
    /** @type {?} */
    ViewFileshareContentComponent.prototype.Documentos;
    /** @type {?} */
    ViewFileshareContentComponent.prototype.modal;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareContentComponent.prototype.fileShareService;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareContentComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/view-fileshare-compare/view-fileshare-compare.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewFileshareCompareComponent {
    /**
     * @param {?} fileShareService
     * @param {?} sanitizer
     */
    constructor(fileShareService, sanitizer) {
        this.fileShareService = fileShareService;
        this.sanitizer = sanitizer;
        this._Url = this.sanitizer.bypassSecurityTrustUrl(null);
        this._Url2 = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    /**
     * @return {?}
     */
    get Url() {
        return this._Url;
    }
    /**
     * @return {?}
     */
    get Url2() {
        return this._Url2;
    }
    /**
     * @return {?}
     */
    get MimeType() {
        return this._mimeType;
    }
    /**
     * @return {?}
     */
    get MimeType2() {
        return this._mimeType2;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.Documentos == null)
            this.Documentos = [];
        this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.isContentDinamico == null || this.isContentDinamico == undefined)
            this.isContentDinamico = true;
    }
    /**
     * @param {?} item
     * @param {?} item2
     * @return {?}
     */
    ViewDocumentos(item, item2) {
        if (item == null) {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //return void 0;
        }
        if (item2 == null) {
            this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            //return void 0;
        }
        if (item.Id == 0)
            return void 0;
        this.fileShareService.GetUrlFolderFileDownload(item.Id).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this._mimeType = response.MimeType == 'application/unknown' ? 'application/pdf' : response.MimeType;
            let [tipo] = response.MimeType.split('/');
            /** @type {?} */
            let encode = encodeURIComponent(response.Url);
            /** @type {?} */
            let url = (tipo == 'image' || this._mimeType == 'application/pdf') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }));
        if (item2 != null && item2.Id != 0) {
            this.fileShareService.GetUrlFolderFileDownload(item2.Id).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                //this._mimeType2 = response.MimeType;
                this._mimeType2 = response.MimeType == 'application/unknown' ? 'application/pdf' : response.MimeType;
                let [tipo] = this._mimeType.split('/');
                /** @type {?} */
                let encode = encodeURIComponent(response.Url);
                /** @type {?} */
                let url = (tipo == 'image' || this._mimeType2 == 'application/pdf') ? response.Url : `https://docs.google.com/gview?url=${encode}&embedded=true`;
                this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            }));
        }
    }
    /**
     * @return {?}
     */
    ShowModal() {
        this.modal.showModal().subscribe((/**
         * @param {?} rseponse
         * @return {?}
         */
        rseponse => {
            this._Url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            this._Url2 = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        }));
    }
    /**
     * @return {?}
     */
    CloseModal() {
        this.modal.closeModal();
    }
}
ViewFileshareCompareComponent.decorators = [
    { type: Component, args: [{
                selector: 'view-fileshare-compare',
                template: "<modal-template #modalTemplate [width-modal]=\"'95%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div class=\"grid\">\r\n    <div class=\"row cells5\">\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n      <div class=\"cell\" style=\"max-height:63vh;\">\r\n        <div [ngClass]=\"{'contentDialog': isContentDinamico }\" style=\"height:63vh;\">\r\n          <ng-content class=\"contentDinamico\"></ng-content>\r\n        </div>\r\n      </div>\r\n      <div class=\"cell colspan2\">\r\n        <iframe [src]=\"Url2\" height=\"63vh\" width=\"100%\" style=\"height: 63vh; width: 100%\"></iframe>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
ViewFileshareCompareComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: DomSanitizer }
];
ViewFileshareCompareComponent.propDecorators = {
    isContentDinamico: [{ type: Input, args: ['isContentDinamico',] }],
    Documentos: [{ type: Input, args: ['documentos',] }],
    modal: [{ type: ViewChild, args: ['modalTemplate', { static: false },] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype._Url;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype._Url2;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype._mimeType;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype._mimeType2;
    /** @type {?} */
    ViewFileshareCompareComponent.prototype.isContentDinamico;
    /** @type {?} */
    ViewFileshareCompareComponent.prototype.Documentos;
    /** @type {?} */
    ViewFileshareCompareComponent.prototype.modal;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype.fileShareService;
    /**
     * @type {?}
     * @private
     */
    ViewFileshareCompareComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare-multiple/fileshare-multiple.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FileshareMultipleComponent {
    /**
     * @param {?} fileShareService
     * @param {?} fb
     */
    constructor(fileShareService, fb) {
        this.fileShareService = fileShareService;
        this.fb = fb;
        this.out = new EventEmitter();
        this.close = new EventEmitter();
        this.click = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.InitFormulario();
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        //this.InitData();
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        //this.InitData();
    }
    /**
     * @return {?}
     */
    InitData() {
        this.data.Documentos.forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            this.addDocumentosFormulario(f.IdDocumento, f.Documento);
        }));
    }
    /**
     * @return {?}
     */
    InitFormulario() {
        this.myForm = this.fb.group({
            Documentos: this.fb.array([])
        });
    }
    /**
     * @return {?}
     */
    get documentosFormulario() {
        if (this.myForm == null)
            return null;
        return (/** @type {?} */ (this.myForm.get('Documentos')));
    }
    /**
     * @param {?} id
     * @param {?} nombreDocumento
     * @return {?}
     */
    addDocumentosFormulario(id, nombreDocumento) {
        /** @type {?} */
        let documento = this.fb.group({
            Id: [id],
            NombreDocumento: [nombreDocumento],
            NumeroReferencia: [null],
            File: [null]
        });
        if (this.documentosFormulario != null) {
            this.documentosFormulario.push(documento);
            documento.get('NumeroReferencia').valueChanges.subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res != null && res != '') {
                    if (documento.get('File').value == null) {
                        documento.get('File').enable({ onlySelf: true, emitEvent: false });
                        documento.get('File').setValidators([Validators.required]);
                    }
                }
                else {
                    documento.get('File').setValidators(null);
                    documento.get('File').disable({ onlySelf: true, emitEvent: false });
                }
                documento.get('File').updateValueAndValidity({ emitEvent: false });
            }));
            documento.get('File').disable({ onlySelf: true, emitEvent: false });
            //documento.get('File').valueChanges.subscribe(res => {
            //  if (res != null) {
            //    documento.get('NumeroReferencia').setValidators([Validators.required])
            //  } else {
            //    documento.get('NumeroReferencia').setValidators(null);
            //  }
            //  documento.get('NumeroReferencia').updateValueAndValidity({ emitEvent: false });
            //})
        }
        ;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getFile(index) {
        //console.log(this.documentosFormulario.at(index).get('File'));
        if (this.documentosFormulario.at(index).get('File').disabled)
            return;
        document.getElementById(`upload${index}`).click();
    }
    /**
     * @param {?} event
     * @param {?} index
     * @return {?}
     */
    uploadChangeFile(event, index) {
        if (event.target.files.length > 0) {
            const [file] = event.target.files;
            this.documentosFormulario.at(index).patchValue({ File: file });
        }
    }
    /**
     * @return {?}
     */
    ViewDocumentos() {
        this.InitData();
        this.myModal.showModal().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.InitFormulario();
            this.close.emit();
        }));
    }
    /**
     * @return {?}
     */
    SaveDocumentos() {
        this.click = true;
        if (!this.myForm.valid) {
            return void 0;
        }
        /** @type {?} */
        let documentos = this.myForm.getRawValue();
        /** @type {?} */
        let documentosBlob = documentos.Documentos.filter((/**
         * @param {?} f
         * @return {?}
         */
        f => f.File != null)).map((/**
         * @param {?} m
         * @return {?}
         */
        m => {
            /** @type {?} */
            let extension = ((/** @type {?} */ (m.File.name))).split('.').pop();
            return DocumentoBlob.getDocumentosBlob(m.File, m.NumeroReferencia, m.File.name, extension, m.Id, m.NombreDocumento);
        }));
        this.fileShareService.UploadDocumentoListBlob(this.data.UserId, this.data.UserName, this.data.IdSistema, this.data.CodigoSistema, documentosBlob, this.data.Identificador, this.data.NombreEmpresa, this.data.CodPaisOperacion, this.data.Datos, this.data.Observacion, this.data.CodPais, this.data.CodOficina).subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event.Event) {
                let [progress] = this.progress.filter((/**
                 * @param {?} _
                 * @param {?} i
                 * @return {?}
                 */
                (_, i) => i == event.Data.Index));
                /** @type {?} */
                let pbTemp = $(progress.nativeElement);
                /** @type {?} */
                let pb = pbTemp.data('progress');
                pb.set(event.Data.Progress);
            }
            else {
                this.out.emit(event.Data);
                //this.myForm.reset(this.fb.array([]), { onlySelf: true } );
                this.click = false;
                this.myModal.closeModal();
            }
        }));
    }
}
FileshareMultipleComponent.decorators = [
    { type: Component, args: [{
                selector: 'fileshare-multiple',
                template: "<modal-template #modalTemplate [width-modal]=\"'60%'\" [height-modal]=\"'70vh'\" [isContentDinamico]=\"false\">\r\n  <div [formGroup]=\"myForm\">\r\n    <div class=\"grid\" formArrayName=\"Documentos\">\r\n      <div class=\"row cells7\" *ngFor=\"let control of documentosFormulario.controls; let i = index\" [formGroupName]=\"i\">\r\n        <div class=\"cell colspan3\">\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" readonly formControlName=\"NombreDocumento\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"cell colspan2\">\r\n\r\n          <div class=\"input-control text full-size\">\r\n            <input type=\"text\" formControlName=\"NumeroReferencia\" placeholder=\"Numero de referencia\" />\r\n          </div>\r\n          <span style=\"margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);\" *ngIf=\"!control.controls.NumeroReferencia.valid && click\" class=\"invalid_feedback float-right\">*</span>\r\n        </div>\r\n        <div class=\"cell align-center\">\r\n          <div class=\"row cell\">\r\n            <button class=\"yourBtn buttonGridAuto\" (click)=\"getFile(i)\">\r\n              <img *ngIf=\"control.controls.File.disabled\"  style=\"opacity:0.5\" src=\"assets/icons/up-green.png\" />\r\n              <img *ngIf=\"!control.controls.File.valid && !control.controls.File.disabled\" src=\"assets/icons/up-yellow.png\" />\r\n              <img *ngIf=\"control.controls.File.valid && control.controls.File.value != null\" src=\"assets/icons/up-green.png\" />\r\n            </button>\r\n          </div>\r\n          <div class=\"row cell\" style=\"margin: 0; position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);\">\r\n            <span *ngIf=\"!control.controls.File.valid && !control.controls.File.disabled && click\" class=\"invalid_feedback float-right\">*</span>\r\n          </div>\r\n          \r\n          \r\n\r\n          <div style='height: 0px;width: 0px; overflow:hidden;'>\r\n            <input id=\"upload{{i}}\" type=\"file\" value=\"upload\" (change)=\"uploadChangeFile($event, i)\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"cell\">\r\n          <div #progressView [attr.data-role]=\"'progress'\" class=\"progress small\" \r\n              data-colors='{\"bg-red\": 33,\"bg-yellow\":66,\"bg-cyan\": 90,\"bg-green\": 100 }'></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row cell\">\r\n        <span *ngIf=\"!myForm.valid && click\" class=\"invalid_feedback float-right\">* Campos obligatarios</span>\r\n      </div>\r\n      <div class=\"row cells12\">\r\n        <div class=\"cell offset11\">\r\n          <button (click)=\"SaveDocumentos()\"><img src=\"assets/icons/save.png\" /></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</modal-template>\r\n",
                styles: [".btnFile{position:relative;top:150px;font-family:calibri;width:150px;padding:10px;-webkit-border-radius:5px;-moz-border-radius:5px;border:1px dashed #bbb;text-align:center;background-color:#ddd;cursor:pointer}"]
            }] }
];
/** @nocollapse */
FileshareMultipleComponent.ctorParameters = () => [
    { type: FileshareService },
    { type: FormBuilder }
];
FileshareMultipleComponent.propDecorators = {
    data: [{ type: Input, args: ['data',] }],
    myModal: [{ type: ViewChild, args: ['modalTemplate', { static: false },] }],
    progress: [{ type: ViewChildren, args: ['progressView',] }],
    out: [{ type: Output, args: ['response',] }],
    close: [{ type: Output, args: ['close',] }]
};
if (false) {
    /** @type {?} */
    FileshareMultipleComponent.prototype.data;
    /** @type {?} */
    FileshareMultipleComponent.prototype.myForm;
    /** @type {?} */
    FileshareMultipleComponent.prototype.myModal;
    /** @type {?} */
    FileshareMultipleComponent.prototype.progress;
    /** @type {?} */
    FileshareMultipleComponent.prototype.out;
    /** @type {?} */
    FileshareMultipleComponent.prototype.close;
    /** @type {?} */
    FileshareMultipleComponent.prototype.click;
    /**
     * @type {?}
     * @private
     */
    FileshareMultipleComponent.prototype.fileShareService;
    /**
     * @type {?}
     * @private
     */
    FileshareMultipleComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fileshare.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let Params = new InjectionToken('Params');
/**
 * @param {?} settings
 * @return {?}
 */
function InitWeb(settings) {
    /** @type {?} */
    let direccion = EnumDireccionesFileShare.FileShareWeb;
    if (settings.Https)
        direccion = EnumDireccionesFileShare.FileShareWebHttps;
    let [direccionWeb] = DireccionesFileShare.filter((/**
     * @param {?} f
     * @return {?}
     */
    f => f.Nombre == direccion));
    return direccionWeb.Direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function InitApi(settings) {
    /** @type {?} */
    let direccion = EnumDireccionesFileShare.FileShareWebApi;
    if (settings.Https)
        direccion = EnumDireccionesFileShare.FileShareWebApiHttps;
    let [direccionApi] = DireccionesFileShare.filter((/**
     * @param {?} f
     * @return {?}
     */
    f => f.Nombre == direccion));
    return direccionApi.Direccion;
}
class FileshareModule {
    /**
     * @param {?=} settings
     * @return {?}
     */
    static forRoot(settings = { Https: false }) {
        return {
            ngModule: FileshareModule,
            providers: [
                { provide: Params, useValue: settings },
                { provide: FILESHARE_WEB, useFactory: InitWeb, deps: [Params] },
                { provide: FILESHARE_API, useFactory: InitApi, deps: [Params] }
            ]
        };
    }
}
FileshareModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FileshareComponent, ViewFileshareComponent, ViewFileshareContentComponent, ViewFileshareCompareComponent, FileshareMultipleComponent],
                imports: [
                    CommonModule, ModalIframeModule, NgSelectModule, ModalModule, ReactiveFormsModule
                ],
                exports: [FileshareComponent, ViewFileshareComponent, ViewFileshareContentComponent, ViewFileshareCompareComponent, FileshareMultipleComponent],
                bootstrap: [FileshareComponent],
                providers: [FileshareService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: fileshare.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DataRequest, DocumentoBlob, DocumentoBto, DocumentoRequestVm, DocumentoResponseVm, EstadoReponseFileShare, FileshareComponent, FileshareModule, FileshareMultipleComponent, FileshareService, FolderBto, FolderFileBto, FolderFileUpdateIdentificadorVm, FolderFileVmGroup, InitApi, InitWeb, Params, ResponseFileShare, ResponseFileShareHojasRutas, ResponseFileShareVm, RespuestaDataRequest, TramiteInfo, UploadMultiple, ViewFileshareCompareComponent, ViewFileshareComponent, ViewFileshareContentComponent, FILESHARE_WEB as ɵa, FILESHARE_API as ɵb };
//# sourceMappingURL=fileshare.js.map
